export type { SdkDocNode, SdkDocEntry } from "./types";
export { SDK_DOCS_TREE } from "./catalog";
export { SDK_DOC_ENTRIES } from "./content";

import { SDK_DOCS_TREE } from "./catalog";
import { SDK_DOC_ENTRIES } from "./content";

export function getSdkDocTree() {
  return SDK_DOCS_TREE;
}

export function getSdkDocContent(docId: string): string | null {
  return SDK_DOC_ENTRIES[docId]?.markdown ?? null;
}

export function getSdkDocTitle(docId: string): string {
  return SDK_DOC_ENTRIES[docId]?.title ?? docId;
}

export function getSdkDocSummary(docId: string): string | undefined {
  return SDK_DOC_ENTRIES[docId]?.summary;
}

/** Collect leaf doc ids for selection sync. */
export function isSdkDocLeafId(docId: string): boolean {
  return docId in SDK_DOC_ENTRIES;
}
